var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _ellipse2, _path11, _ellipse3, _ellipse4, _path12, _ellipse5, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrubhubVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.21 53h97.802a37.1 37.1 0 00.071-2.294c0-20.272-16.434-36.706-36.706-36.706-17.348 0-31.885 12.035-35.718 28.212a22.988 22.988 0 00-5.576-.683c-8.492 0-15.905 4.614-19.872 11.471z",
    fill: "url(#grubhub-vehicle_svg__paint0_linear_911_42963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.923 39h112.886c-2.367-8.52-10.181-14.773-19.455-14.773-1.692 0-3.336.208-4.906.6C86.075 10.591 73.28 0 58.014 0c-12.96 0-24.138 7.633-29.283 18.648a23.321 23.321 0 00-4.712-.478C12.003 18.17 2.12 27.299.923 39z",
    fill: "url(#grubhub-vehicle_svg__paint1_linear_911_42963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.25 117.573h144.855v24.094H11.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.883 141.714H59.327c0-11.708-10.198-21.2-22.777-21.2-12.58 0-22.778 9.492-22.778 21.2h-9.54a2.1 2.1 0 01-2.08-1.817l-.85-6.266a3.553 3.553 0 013.521-4.031l-1.842-9.143c-.33-1.641.139-4.172 1.024-5.613l11.394-18.558c.089-.305 10.581-22.04 10.581-22.04C28.223 69.693 34.413 66 39.785 66h42.323c7.187 0 16.352 4.439 20.469 9.913l20.203 26.43 16.309 1.533c13.457.826 21.711 11.378 18.448 23.527l-.59 2.197c2.936 0 4.804 3.14 3.404 5.72l-2.874 5.296a2.098 2.098 0 01-1.845 1.098h-5.193c0-11.708-10.198-21.2-22.778-21.2-12.58 0-22.778 9.492-22.778 21.2z",
    fill: "url(#grubhub-vehicle_svg__paint2_linear_911_42963)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.476 119.315a3.165 3.165 0 011.676-3.338c2.096-1.078 4.616.43 4.616 2.786v6.112a2.65 2.65 0 01-5.263.447l-1.029-6.007z",
    fill: "#C7222B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.412 99.242H13.586l1.815-2.956c.09-.305 10.582-22.04 10.582-22.04.575-1.168 1.411-2.28 2.426-3.288h68.704c2.203 1.458 4.109 3.15 5.467 4.955l17.832 23.33z",
    fill: "#BAE5EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.411 99.242H59.539V70.958h37.573c2.203 1.458 4.109 3.15 5.467 4.955l17.832 23.33z",
    fill: "url(#grubhub-vehicle_svg__paint3_linear_911_42963)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.862 93.27a3.099 3.099 0 011.868-3.964l32.19-11.568a3.098 3.098 0 112.096 5.832l-32.19 11.568a3.099 3.099 0 01-3.964-1.868zM37.862 91.593a3.099 3.099 0 011.868-3.964l32.19-11.568a3.099 3.099 0 112.096 5.832l-32.19 11.568a3.099 3.099 0 01-3.964-1.868z",
    fill: "#fff",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.327 141.714h45.556c0-4.495 1.503-8.663 4.067-12.093H55.26c2.564 3.43 4.067 7.598 4.067 12.093zM17.839 129.621H4.433a3.554 3.554 0 00-3.13 4.01l.85 6.266a2.1 2.1 0 002.08 1.817h9.539c0-4.495 1.503-8.663 4.067-12.093zM157.359 129.621h-10.987c2.564 3.43 4.067 7.598 4.067 12.093h5.193c.77 0 1.478-.421 1.845-1.098l2.874-5.296c1.334-2.457-.297-5.422-2.992-5.699z",
    fill: "#F75400"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.327 141.714h45.556c0-1.267.119-2.508.348-3.714H58.978c.23 1.206.349 2.447.349 3.714zM14.12 138H1.894l.257 1.897a2.1 2.1 0 002.08 1.817h9.539c0-1.267.12-2.508.348-3.714zM158.896 138h-8.806a19.89 19.89 0 01.348 3.714h5.193a2.1 2.1 0 001.846-1.098l1.419-2.616z",
    fill: "#000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.525 75.185c1.308.25 2.096 1.692 1.497 2.96l-8.4 17.758a2.1 2.1 0 01-1.897 1.202h-1.832l-2.573 4.191h109.657l-3.203-4.19h-9.066a2.1 2.1 0 01-1.788-1L96.989 78.349c-.861-1.399.145-3.2 1.787-3.2h3.185C97.599 70.03 88.954 66 82.105 66H39.782c-5.372 0-11.561 3.692-13.804 8.247l-.453.938zm8.038 1.165a2.1 2.1 0 011.898-1.202h19.357c1.16 0 2.1.94 2.1 2.1v17.758a2.1 2.1 0 01-2.1 2.1H27.062a2.1 2.1 0 01-1.898-2.998l8.4-17.758zm54.305-1.202a2.1 2.1 0 011.788.999l10.932 17.758c.861 1.4-.145 3.2-1.788 3.2H64.32a2.1 2.1 0 01-2.1-2.099V77.247c0-1.16.94-2.1 2.1-2.1h23.55z",
    fill: "url(#grubhub-vehicle_svg__paint4_linear_911_42963)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.938 69.923c0-1.05.851-1.903 1.902-1.903h27.766a1.903 1.903 0 110 3.806H48.84a1.903 1.903 0 01-1.904-1.903zM19.348 108.543a2.379 2.379 0 012.378-2.379h27.766a2.379 2.379 0 010 4.758H21.726a2.379 2.379 0 01-2.378-2.379zM80.547 69.923c0-1.05.852-1.903 1.903-1.903h1.23a1.903 1.903 0 110 3.806h-1.23a1.903 1.903 0 01-1.903-1.903zM11.719 108.52a2.379 2.379 0 012.379-2.379h1.23a2.379 2.379 0 010 4.758h-1.23a2.379 2.379 0 01-2.38-2.379z",
    fill: "#fff",
    fillOpacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.935,
    cy: 115.82,
    rx: 3.674,
    ry: 7.333,
    transform: "rotate(-34 147.935 115.82)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.766,
    cy: 142.191,
    rx: 17.845,
    ry: 17.808,
    fill: "url(#grubhub-vehicle_svg__paint5_radial_911_42963)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.39 142.191c0-8.06-6.548-14.594-14.624-14.594",
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 2.86,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.829,
    cy: 142.192,
    rx: 7.868,
    ry: 7.791,
    fill: "url(#grubhub-vehicle_svg__paint6_linear_911_42963)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.446,
    cy: 142.191,
    rx: 17.845,
    ry: 17.808,
    fill: "url(#grubhub-vehicle_svg__paint7_radial_911_42963)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.07 142.191c0-8.06-6.548-14.594-14.625-14.594",
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 2.86,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.508,
    cy: 142.192,
    rx: 7.868,
    ry: 7.791,
    fill: "url(#grubhub-vehicle_svg__paint8_linear_911_42963)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.593 114.436c.263-.187.488-.388.7-.625l-.012.012a4.62 4.62 0 001.114-3.153v-.025a4.49 4.49 0 00-1.164-3.091l.05.05a4.138 4.138 0 00-2.978-1.389H55.15a.251.251 0 00-.25.25v13.928c0 .137.112.25.25.25h2.465c.138 0 .25-.113.25-.25v-5.156h.914l1.564 5.256c.025.1.125.175.238.175h2.627c.075 0 .15-.038.2-.1a.216.216 0 000-.213l-1.814-5.919zm-1.527-2.565c-.25.275-.6.413-.976.401h-1.213v-3.104h1.2c.376-.012.727.125.99.401v-.013c.262.313.387.701.375 1.101v.013c.025.45-.1.863-.376 1.201zM51.947 107.229a4.226 4.226 0 00-3.104-1.227h-.025a4.18 4.18 0 00-3.103 1.227l.025-.038a4.608 4.608 0 00-1.126 3.278v5.932a4.594 4.594 0 001.063 3.278 4.182 4.182 0 003.091 1.214h.05a4.174 4.174 0 003.104-1.226 4.597 4.597 0 001.063-3.279v-3.241c-.012-.137-.112-.25-.25-.25h-3.642a.271.271 0 00-.262.25v2.428c.012.15.112.25.262.25h1.002v.551c.025.413-.1.826-.35 1.163l.012-.012c-.213.275-.55.425-.901.4h-.013a1.031 1.031 0 01-.9-.388 1.746 1.746 0 01-.364-1.163v-5.894a1.79 1.79 0 01.388-1.189c.213-.275.55-.425.901-.4h.013c.35-.025.688.112.9.388l.013.012c.226.351.338.764.3 1.176v.551c.013.125.113.213.25.213h2.478c.126 0 .238-.088.25-.213v-.551a4.667 4.667 0 00-1.126-3.24zM94.266 106.24H91.79a.251.251 0 00-.25.251v5.393h-2.503v-5.393a.251.251 0 00-.25-.251H86.32a.251.251 0 00-.25.251v13.902c0 .138.112.25.25.25h2.465a.25.25 0 00.25-.25V114.8h2.503v5.593c0 .138.112.25.25.25h2.465a.25.25 0 00.25-.25v-13.902c0-.138-.1-.251-.238-.251zM73.509 116.376v-9.923a.233.233 0 00-.238-.213h-2.528c-.125 0-.238.088-.25.213v9.923c.012.413-.1.813-.35 1.126a1.118 1.118 0 01-1.565.075.298.298 0 01-.087-.087 1.661 1.661 0 01-.326-1.101v-9.936c0-.125-.1-.225-.225-.225h-2.552a.225.225 0 00-.25.2v9.936a4.595 4.595 0 001.063 3.278 4.19 4.19 0 003.09 1.214h.038a4.19 4.19 0 003.09-1.214 4.457 4.457 0 001.09-3.266zM115.753 116.188v.012a3.84 3.84 0 00-1.439-3.003l.012.013.013-.013a3.831 3.831 0 001.176-2.765v.05a4.28 4.28 0 00-1.064-2.979l.013.025a3.987 3.987 0 00-3.041-1.326h-3.954a.25.25 0 00-.25.25v13.94c0 .138.112.25.25.25h4.117a4.173 4.173 0 003.241-1.476l-.013.012a4.407 4.407 0 00.939-2.99zm-5.569-7.02h1.239c.313-.025.613.1.826.313l.013.012c.212.288.312.651.287 1.014.038.375-.087.763-.312 1.088v-.012a1.028 1.028 0 01-.826.35h-1.252v-2.765h.025zm2.666 7.032c.012.426-.113.826-.363 1.151l.012.013.013-.013a1.092 1.092 0 01-.926.388h-1.402v-3.003h1.414c.351-.025.689.113.926.388l-.012-.012c.238.312.363.7.338 1.088zM105.04 116.375v-9.923c-.013-.112-.113-.213-.225-.213h-2.541a.227.227 0 00-.25.201v9.935a1.76 1.76 0 01-.325 1.114 1.136 1.136 0 01-1.577.088.317.317 0 01-.087-.088 1.656 1.656 0 01-.326-1.101v-9.936c-.012-.125-.112-.213-.25-.213h-2.54c-.125 0-.238.088-.25.213v9.948a4.573 4.573 0 001.063 3.254l.025.025a4.617 4.617 0 006.232-.05l-.038.025a4.563 4.563 0 001.089-3.279zM84.23 116.188v.037a3.862 3.862 0 00-1.439-3.015l.013-.013a3.825 3.825 0 001.176-2.753 4.238 4.238 0 00-1.064-2.865v-.013a3.986 3.986 0 00-3.04-1.326h-3.942a.25.25 0 00-.25.25v13.902c0 .138.112.25.25.25h4.142a4.172 4.172 0 003.24-1.476l-.012.012a4.46 4.46 0 00.926-2.99zm-5.593-7.02h1.239c.312-.025.613.1.825.325l.013.013c.213.287.313.65.288 1.013.037.376-.088.764-.313 1.089v-.013a1.03 1.03 0 01-.826.351h-1.251v-2.778h.025zm2.678 7.032a1.78 1.78 0 01-.363 1.151l.012.013.013-.013a1.092 1.092 0 01-.926.388h-1.402v-3.003h1.414c.35-.025.688.113.926.388l-.012-.012c.237.312.35.7.338 1.088z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint0_linear_911_42963",
    x1: 112.147,
    y1: 14,
    x2: 112.147,
    y2: 66.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint1_linear_911_42963",
    x1: 57.366,
    y1: 0,
    x2: 57.366,
    y2: 54.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint2_linear_911_42963",
    x1: 81.595,
    y1: 103.857,
    x2: 96.093,
    y2: 146.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint3_linear_911_42963",
    x1: 91.554,
    y1: 70.958,
    x2: 102.848,
    y2: 93.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C90A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint4_linear_911_42963",
    x1: 70.784,
    y1: 64.672,
    x2: 80.16,
    y2: 98.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint6_linear_911_42963",
    x1: 127.829,
    y1: 142.192,
    x2: 131.391,
    y2: 147.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grubhub-vehicle_svg__paint8_linear_911_42963",
    x1: 36.508,
    y1: 142.192,
    x2: 40.071,
    y2: 147.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9248"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "grubhub-vehicle_svg__paint5_radial_911_42963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 11.7478 -11.7715 0 127.766 142.191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6821E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32270B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "grubhub-vehicle_svg__paint7_radial_911_42963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 11.7478 -11.7715 0 36.446 142.191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6821E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32270B"
  })))));
}
export default __webpack_public_path__ + "static/media/grubhub-vehicle.61295e8a.svg";
export { SvgGrubhubVehicle as ReactComponent };